export default (node) => {
  const submenuLinks = node.querySelectorAll('[data-mobile-menu-top-link]');
  const submenus = node.querySelectorAll('[data-mobile-submenu]');
  const submenuCloseLinks = node.querySelectorAll(
    '[data-mobile-submenu-close]'
  );
  const tertiaryMenuLinks = node.querySelectorAll('[data-tertiary-menu-link]');
  const tertiaryMenus = node.querySelectorAll('[data-tertiary-menu]');
  const tertiaryCloseLinks = node.querySelectorAll(
    '[data-tertiary-menu-close]'
  );

  const init = () => {
    submenuLinks.forEach((submenuLink) => {
      submenuLink.addEventListener('click', (e) => {
        e.preventDefault();
        let linkText = submenuLink.innerText;
        let menu = [...submenus].filter((submenu) => {
          return submenu.dataset.mobileSubmenu === linkText;
        })[0];
        if (menu) {
          menu.scrollTop = 0;
          menu.classList.remove('translate-x-full');
        }
      });
    });

    submenuCloseLinks.forEach((closeLink) => {
      closeLink.addEventListener('click', (e) => {
        e.preventDefault();
        closeLink
          .closest('[data-mobile-submenu]')
          .classList.add('translate-x-full');
      });
    });

    tertiaryMenuLinks.forEach((tertiaryLink) => {
      tertiaryLink.addEventListener('click', (e) => {
        e.preventDefault();
        let linkText = tertiaryLink.dataset.tertiaryMenuLink;
        let tertiaryMenu = [...tertiaryMenus].filter((tertiaryMenu) => {
          return tertiaryMenu.dataset.tertiaryMenu === linkText;
        })[0];

        const closestMenuWrapper = tertiaryLink.closest(
          '[data-mobile-submenu]'
        );

        tertiaryMenu.classList.remove('translate-x-full');
        if (closestMenuWrapper) {
          closestMenuWrapper.scrollTop = 0;
        }
      });
    });

    tertiaryCloseLinks.forEach((closeLink) => {
      closeLink.addEventListener('click', (e) => {
        e.preventDefault();
        closeLink
          .closest('[data-tertiary-menu]')
          .classList.add('translate-x-full');
      });
    });
  };

  init();
};
